import React from 'react';
import hoc from './FieldHOC';

class Handling extends React.Component{

  constructor(){
    super(...arguments);
    this.state = {};
  }

  onChange(e) {
    this.setState({
      checked: e.target.value === 'on'
    });
    this.props.onChange(e.target.value === 'on');
    this.props.field.setChecked(e.target.value === 'on');
  }

  render(){
    let field = this.props.field;
    return (
      <div className="checkbox">
        <label htmlFor={this.props.name}>
          <input type="checkbox" name={this.props.name} tabIndex={this.props.tabIndex} onChange={this.onChange.bind(this)} defaultChecked={field.prop('default_checked')} /> {this.props.title || field.get('title')}
          {this.props.errorComponent}
        </label>
      </div>
    );
  }

}

export default hoc(Handling);
